export default {
  add_expert_report: 'Lägg till expertrapport',
  menu: 'Admin',
  menu_login: 'Logga in',
  menu_logout: 'Logga ut',
  loginLatest_header: 'Senaste inloggning',
  details: 'Detaljer',
  user_edit: 'Redigera användare',
  first_name: 'Förnamn',
  last_name: 'Efternamn',
  username: 'Användarnamn',
  username_enter: 'Skriv in användarnamn',
  password: 'Lösenord',
  password_enter: 'Skriv in ditt lösenord',
  password_change: 'Ändra lösenord',
  password_confirm: 'Bekräfta lösenord',
  password_mismatch: 'Lösenorden överenstämmer inte med varandra',
  password_wrongFormat:
  'Överenstämmer inte med lösenordpolicy (minst 6 tecken och minst 1 siffra)',
  teamprofile_change: 'Teamprofiler',
  email: 'E-postadress',
  language: 'Språk',
  company: 'Företag',
  credits: 'Krediter',
  credits_inline: 'krediter',
  userDelete_confirmation: 'Vill du radera användaren?',
  userDelete_message: 'Användaren har raderats',
  usergroups_header: 'Kunder och användare',
  usergroup_header: 'Kund',
  usergroup_add_new: 'Lägg till kund',
  usergroup_add_user: 'Lägg till användare',
  urlTag: 'URL-tag',
  urlTag_feedback: 'Endast bokstäver och siffror utan mellanslag',
  customerType_header: 'Typ',
  customerType_supplier: 'Leverantör',
  customerType_reseller: 'Återförsäljare',
  customerType_customer: 'Kund',
  customers_header: 'Kunder',
  orgNumber: 'Organisationsnummer',
  orgNumberFormat: 'Format: {format}',
  logoChoice: 'Välj en bild {logo}',
  groupDelete_confirmation: 'Vill du radera gruppen?',
  groupDelete_message: 'Gruppen har raderats',
  groupDelete_error_message:
    'Det gick inte att radera gruppen. Se till att den är tom först',
  testmethods_header: 'Testmetoder',
  testmethod_header: 'Testmetod',
  testmethod_add_header: 'Lägg till testmetod',
  testmethod_unsupported_info: 'Den valda testmetoden stöds ej ännu för att generera teamrapporter.',
  my_testmethod_header: 'Min testmetod',
  my_testmethods_header: 'Mina testmetoder',
  my_testmethods_add_new: 'Lägg till ny testmetod',
  standard_testmethods_header: 'Standard',
  testbuilder_testmethods_header: 'Test Builder',
  testbuilder_used_for: 'För Test Builder',
  custom_testmethods_question_format: 'Frågeformat',
  custom_testmethods_estimated_time: 'Estimerad totaltid',
  custom_testmethods_estimated_time_info:
    'Den estimerade tiden det tar att göra testet (i minuter).',
  custom_testmethods_available_scales: 'Tillgängliga skalor',
  custom_testmethods_added_scales: 'Valda skalor',
  testmethodDelete_confirmation: 'Vill du radera testmetoden?',
  testmethodDelete_message: 'Testmetoden har raderats',
  isUsedForTestBuilder_label: 'Används i Psytest Builder',
  error_scales_count: 'Välj minst tre skalor',
  scale: 'Skala',
  scales_header: 'Skalor',
  scale_header: 'Redigera skala',
  scale_add_header: 'Lägg till skala',
  scale_langDetail_header: 'Beskrivningar',
  scaleDelete_confirmation: 'Vill du radera skalan?',
  scaleDelete_message: 'Skalan har raderats',
  translationDelete_confirmation: 'Vill du radera översättningen?',
  translationDelete_message: 'Översättningen har raderats',
  scaleQuestionsHandle: 'Redigera frågor',
  scaleQuestions_header: 'Redigera frågor',
  scaleQuestionFormatRequired_message: 'Frågeformat måste väljas',
  scaleQuestionsUploadImage: 'Ladda upp bild',
  scaleQuestionsAlternativeAdd: 'Lägg till alternativ',
  scaleQuestionsAdd: 'Lägg till fråga',
  scaleQuestionsDelete: 'Ta bort fråga',
  scaleQuestionsCorrectAnswer: 'Rätt svar',
  scaleQuestionsAnswer: 'Svarsalternativ',
  scaleIsRandomizedLogicTest: 'Slumpat logiktest',
  numericalImageType_header: 'Typ',
  logicTestLevel_desc: 'Nivå',
  instructions_header: 'Instruktioner',
  instruction_add_header: 'Lägg till instruktion',
  instruction: 'Instruktion',
  pageIndex_header: 'Sida {page}',
  exerciseQuestion: 'Övningsfråga',
  isStandardInstruction: 'Använd som standardinstruktion',
  correctAnswerMessage: 'Rätt svar',
  incorrectAnswerMessage: 'Fel svar',
  noAnswerMessage: 'Inget svar',
  page: 'Sida',
  addPage: 'Lägg till sida',
  pageDelete_confirmation: 'Vill du radera sidan?',
  instructionDelete_confirmation: 'Vill du radera instruktionen?',
  instructionDelete_message: 'Instrutionen har raderats',
  instruction_exerciseQuestion_header: 'Övningsfråga',
  instruction_answerMessages_header: 'Svarsmeddelanden',
  instruction_disable_question: 'Använd ej fråga',
  lowEndDescription: 'Beskrivning låg nivå',
  highEndDescription: 'Beskrivning hög nivå',
  lowEndCoachingDescription: 'Coachande beskrivning låg nivå',
  highEndCoachingDescription: 'Coachande beskrivning hög nivå',
  status_header: 'Status',
  questionFormat_header: 'Frågeformat',
  pdfType_header: 'Pdf-typ',
  creditCost_header: 'Kreditkostnad',
  credits_header: 'Krediter',
  credits_feedback: 'Kredit måste fyllas i som ett numeriskt värde',
  evaluation_label: 'För evaluering',
  excelExportEnabled_label: 'Tillåt Excel-export',
  lsiCoachingAvailable_label: 'LSI-coaching tillgängligt',
  isActive: 'Aktiv',
  isLimited: 'Tidsbegränsat test',
  imageBank: 'Bildbank',
  imageBankGetImage: 'Från bildbank',
  imageBankAddFolder: 'Ny mapp',
  imageBankAddImage: 'Ladda upp bild',
  folder: 'Mapp',
  credits_error_feedback:
    'Kreditkostnad måste fyllas i som ett numeriskt värde',
  availableNormgroups_header: 'Tillgängliga normgrupper',
  normgroup: 'Normgrupp',
  normgroups_header: 'Normgrupper',
  normgroup_edit_header: 'Redigera normgrupp',
  normgroup_confirmation: 'Vill du radera normgruppen?',
  normgroup_message: 'Normgruppen har raderats',
  normgroup_add_new: 'Lägg till normgrupp',
  testsuite_create: 'Skapa testsvit',
  testsuite_type: 'Välj testtyp',
  testsuite_header: 'Testsvit',
  testsuite_create_header: 'Skapa ny testsvit',
  testsuite_tests: 'Tester',
  testsuite_info: 'Info',
  testsuite_participants: 'Testdeltagare',
  testsuite_expiration_date: 'Utgångsdatum',
  testsuite_group_customer: 'Tagg',
  testsuite_add_participant: 'Lägg till testdeltagare',
  testsuite_added_participants: 'Tillagda testdeltagare',
  testsuite_unsaved_participants_feedback:
    'Du har osparade testdeltagare. Vill du lägga till hen i testsviten?',
  testsuite_no_participants_feedback:
    'Du måste lägga till minst en deltagare i testsviten.',
  testsuite_invalid_participant_feedback: 'Kunde ej spara testdeltagare.',
  testsuite_no_link_added: "Var vänlig och lägg till {'{link}'} i texten.",
  testsuite_email: 'E-post',
  testsuite_at_place: 'På plats',
  testsuite_anonymous: 'Anonym',
  testsuite_alias: 'Alias',
  testsuite_load_email_template: 'Ladda från mall',
  testsuite_email_save_template: 'Spara ny mall',
  testsuite_email_delete_template: 'Ta bort mall',
  testsuite_email_templates: 'Mallar',
  testsuite_email_message: 'Meddelande',
  testsuite_email_subject: 'Ärende',
  testsuite_email_possible_tags: 'Möjliga taggar',
  testsuite_included_testmethods: 'Tillagda testmetoder',
  testsuite_customer_add_new: 'Lägg till ny',
  testsuite_customer_load_from_list: 'Välj..',
  testsuite_testmethod_type: 'Typ',
  testsuite_email_template_deleted: 'Mallen har raderats',
  standard_testmethods: 'Standardtestmetoder',
  my_testmethods: 'Mina testmetoder',
  customerTag_confirmation: 'Vill du radera taggen?',
  customerTag_message: 'Taggen har raderats',
  pin: 'PIN',
  testmethodType_standard: 'Standard',
  testmethodType_testbuilder: 'Testbuilder',
  question_time: 'Tid per fråga',
  test_time: 'Tid per test',
  question_time_description:
    'Den estimerade tiden det tar att svara på en fråga (i sekunder).',
  test_time_description:
    'Den estimerade tiden det tar att genomföra ett test (i minuter).',
  testDelete_confirmation: 'Vill du radera testet?',
  testDelete_message: 'Testet har raderats',
  testDelete_error_message: 'Det gick inte att radera testet',
  my_profile_header: 'Min profil',
  transaction_history: 'Sök transaktionshistorik',
  transaction_start: 'Startdatum',
  transaction_end: 'Slutdatum',
  see_transactions: 'Se transaktioner',
  show_inactive: 'Visa inaktiva',
  stringEMInsufficientCredits:
    'Du har inte tillräckligt med krediter för att generera rapporten. Kontakta din återförsäljare för mer information',
  minutes: 'minuter',
  expert_report_header: 'Analys direkt',
  expert_report_cost: 'Den här rapporten kostar {credits} krediter extra.',
  expert_report_please_select: 'Vänligen välj {selection}.',
  expert_report_type_TeamReport: 'LSI Ledarstilsinventorium',
  expert_report_invalid_selection:
    'Denna Analys direkt-rapport finns ej tillgänglig för de gjorda valen.',
  expert_report_invalid_selection_team:
    'Denna rapport finns ej tillgänglig för de gjorda valen.',
  expert_report_edit_translations: 'Redigera översättningar',
  expert_report_edit_title: 'Redigera rubrik',
  expert_report_edit_item_header: 'Redigera innehåll',
  expert_report_name_header: 'Rapportnamn',
  expert_pdf_report_name_header: 'PDF rapportnamn',
  expert_pdf_report_subtitle: 'PDF underrubrik',
  expert_report_title_header: 'Rubrik',
  expert_report_description_header: 'Beskrivning',
  expert_report_text_header: 'Text',
  expert_report_conditions_header: 'Villkor',
  expert_report_content_header: 'Innehåll',
  expert_report_add_report: 'Lägg till rapport',
  expert_report_edit_report: 'Redigera rapport',
  expert_report_delete_confirmation: 'Vill du radera rapporten?',
  expert_report_delete_message: 'Rapporten har raderats',
  expert_report_new_text_with_terms: 'Ny text med villkor',
  expert_report_new_header: 'Ny rubrik',
  expert_report_new_subheader: 'Ny underrubrik',
  expert_report_select_header: 'Placeras under rubrik:',
  expert_report_select_subheader: 'Placeras under rubrik:',
  expert_report_formulas: 'Formler',
  expert_report_formulas_and: 'och',
  expert_report_formulas_and_operator: '&&',
  expert_report_formulas_or: 'eller',
  expert_report_formulas_or_operator: '||',
  expert_report_formulas_gt: 'större än',
  expert_report_formulas_gt_operator: '>',
  expert_report_formulas_lt: 'mindre än',
  expert_report_formulas_lt_operator: '<',
  expert_report_formulas_eq: 'lika med',
  expert_report_formulas_eq_operator: '==',
  expert_report_formulas_gteq: 'större än eller lika med',
  expert_report_formulas_gteq_operator: '>=',
  expert_report_formulas_lteq: 'mindre än eller lika med',
  expert_report_formulas_lteq_operator: '<=',
  expert_report_formulas_example:
    '(PÅV == 4 && STR == 4) && (ENE > 8 || ENE == 5)',
  expert_report_formatting: 'Formatering',
  expert_report_formatting_12_BOL_start: '<style="12_BOL">',
  expert_report_formatting_12_BOL_example: 'Storlek 12 i fetstil',
  expert_report_formatting_12_BOL_UL_ITA_start: '<style="12_BOL_UL_ITA">',
  expert_report_formatting_12_BOL_UL_ITA_example:
    'Storlek 12 i fetstil, understruken och kursiv',
  expert_report_formatting_end: '</style>',
  usergroup_has_test_interpreter_permissions: 'Tolkningsrättigheter',
  testmethod_order_header: 'Frågeordning',
  testmethod_unsorted_warning: 'Osorterad',
  testmethod_randomize: 'Slumpa',
  testmethod_isUsedWithoutStaticTexts: 'Dölj statiska texter',
  testdata_header: 'Dataexport',
  testdata_start_date: 'Från och med:',
  testdata_end_date: 'Till och med:',
  testdata_select_testmethods: 'Välj vilka test som ska exporteras:',
  testdata_date_filter: 'Filtrering på startdatum för test (töm fälten för alla test)',
  testdata_export: 'Export'
}
